// User action types
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_DISABLED = "LOGIN_DISABLED";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_PROFILE_PICTURE = "UPDATE_PROFILE_PICTURE";
export const UPDATE_VIEW_MODE = "UPDATE_VIEW_MODE";

// Notification action types
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const RECEIVE_NOTIFICATION = "RECEIVE_NOTIFICATION";
export const RECEIVE_NOTIFICATION_HISTORY = "RECEIVE_NOTIFICATION_HISTORY";
export const SUBSCRIBE_NOTIFICATION = "SUBSCRIBE_NOTIFICATION";
export const UNSUBSCRIBE_NOTIFICATION = "UNSUBSCRIBE_NOTIFICATION";
